export default {
  type: 'array',
  minItems: 2,
  items: {
    type: 'number'
  }
};
